import React, {useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import Avatar from '@material-ui/core/Avatar';
import checkUtils from '../../../util/checkUtils'
import { NotificationManager } from 'react-notifications';
import _ from "lodash";
import dashServerApis from '../../../util/dashServerApis'
import DStyles from '../../../components/DStyles'

export default (props) => {
	let check = props.check
	let setScrollIndicator = props.setScrollIndicator
	let offset = window.innerHeight * (props.offset/-100)
	let debug = true
	let tableEnd 

	useEffect(() => {
		checkVisibility()
	})

	const isInViewport = () => {
		if (!tableEnd) return false;
		const top = tableEnd.getBoundingClientRect().top;
		return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
	}

	const handleScroll = () => {
		checkVisibility()
	}
	const checkVisibility = () => {
		setScrollIndicator(isInViewport(offset))
	}

	const clickedCheckItem = (event, item) => {
		// scrollToBottom()
		let index = _.indexOf(check.items, item)
		let lockedByName = (item.lockedBy && item.lockedBy !== ' ') ? item.lockedBy : ''
		if (item.paid) {
			NotificationManager.warning('', lockedByName + " has already paid for this item.", 3000);
		} else if (item.locked) {
			if (item.lockedByMe) {
				//UNLOCK
				item.locked = false
				item.lockedByMe = false
				item.lockedByInitials = ""
				dashServerApis.unlockItems(check, [item], debug);
			} else {
				//ITEM LOCKED BY SOMEONE ELSE, YOU CAN'T TAKE THIS
				//SHOW ALERT THAT IT IS LOCKED
				NotificationManager.warning('', lockedByName + " has selected this item.", 3000);
			}
		} else {
			//LOCK
			item.locked = true
			item.lockedByMe = true
			item.lockedByInitials = (localStorage.initials) ? localStorage.initials : ''
			//UPDATE check state
			dashServerApis.lockItems(check, [item], debug);
		}

		//UPDATE THE STATE/UI IN REAL-TIME EVEN THOUGH IT WILL UPDATE AGAIN WHEN IT GETS A RESPONSE FROM THE SERVER
		let checkClone = _.cloneDeep(check)
		checkClone.items[index] = item
		checkClone = checkUtils.updateTotals(checkClone)
		global.set({ check: checkClone })
	}

	const styles = `

		.selectItemsGrid {
			overflow-x: hidden;
			overflow-y: auto;
			height: 100%;
		}

		.selectItemsGrid::-webkit-scrollbar {
			width: 0 !important;
			display: none;
			background: transparent;
		}

		.selectItemsTable {
			width: 100%;
			border-collapse: collapse;
			border-spacing: 0;
		}

		.selectItemsTable tbody tr:last-child > td {
			border-bottom: none;
		}

		.selectItemsTable th {
			padding-left: 10px;
			padding-right: 0px;
			padding-bottom: 4px;
			font-size: 1em;
			font-weight: 600;
			border-bottom: none;
		}

		.selectItemsTable td {
			border-left: solid 2px #FFF;
			border-right: solid 2px #FFF;
			border-bottom: dashed 1px #CCC;
		}

		.selectItemsTable th:last-child, td:last-child {
			padding-right: 10px;
			text-align: right;
		}

		.selectItemsTable::-webkit-scrollbar {
			width: 0 !important;
			background: transparent;
		}

		.selectItemsTable tbody tr td .item-name {
			margin-left: 10px;
			margin-top: 3px;
		}

		.selectItemsTable tbody tr td .item-modifier {
			margin-left: 10px;
			font-size: .75em;
			color: var(--light-gray)
		}

		.selectItemsTable tbody tr.lockedByMe td .item-modifier {
			color: var(--white)
		}

		.selectItemsTable tbody tr.paid td {
			color: "#A1A1A1";
		}
		.selectItemsTable tbody tr.paid td .item-name {
			textDecoration: 'line-through';
		}

		.selectItemsTable tbody tr.locked {
			font-weight: 600;
			font-family: "Roboto Light", "Helvetica", "Arial", sans-serif;
			color: var(--purple-text);
		}

		.selectItemsTable tbody tr.locked td {
			border-left: solid 2px #F2F2F2;
			border-right: solid 2px #F2F2F2;
			background-color: #F2F2F2;
		}

		.selectItemsTable tbody tr.lockedByMe {
			font-weight: 600;
			font-family: "Roboto Light", "Helvetica", "Arial", sans-serif;
		}
		.selectItemsTable tbody tr.lockedByMe td {
			color: #FFFFFF;
			border-left: solid 2px var(--purple-text);
			border-right: solid 2px var(--purple-text);
			background-color: var(--purple-text);
			font-weight: 800;
		}

		.selectItemsTable tbody tr .circle {
			margin: 0px;
			padding: 0px;
			width: 24px;
			height: 24px;
			font-size: 11px;
			font-weight: 600;
			color: #FFFFFF !important;
			background-color: #FFF;
			border: solid 1px #e0e0e0;
		}

		.selectItemsTable tbody tr.paid .circle {
			background-color: #D9D9D9;
		}

		.selectItemsTable tbody tr.locked .circle {
			color: #878787 !important;
		}

		.selectItemsTable tbody tr.lockedByMe .circle {
			color: var(--purple-text) !important;
			background-color: #F2F2F2;
		}
	`


	return (
		<Grid container className={"selectItemsGrid"} onScroll={handleScroll}>
			<DStyles styles={styles} />
			<Table className={"selectItemsTable"} >
				<TableHead>
					<TableRow>
						<TableCell>ITEM</TableCell>
						<TableCell>AMOUNT</TableCell>
					</TableRow>
				</TableHead>
				<TableBody style={{ width: '100%' }} >
					{check.items.map((item, index) => {
						let rowClassName
						if (item.paid) {
							rowClassName = "paid"
						} else if (item.locked) {
							if (item.lockedByMe) {
								rowClassName = "lockedByMe"
							} else {
								rowClassName = "locked"
							}
						}
						return (
							<TableRow
								key={item._id}
								onClick={(event) => { clickedCheckItem(event, item) }}
								className={rowClassName}
							>
								<TableCell style={{paddingRight: 0}}>
									<div style={{display: 'flex'}}>
										<Avatar className="circle">{item.locked && item.lockedByInitials}</Avatar>
										<div className="item-name">{item.name}{item.modifierString && <div className="item-modifier">{item.modifierString}</div>}</div>
									</div>
								</TableCell>
								<TableCell>
									{item.paid &&  "PAID"}
									{!item.paid && <div>{checkUtils.formatMoney(item.price)}</div>}
									{index + 1 === check.items.length &&
										<div 
											ref={(el) => { tableEnd = el; }}>
										</div>
									}
								</TableCell>
								
							</TableRow>
						);
					})}
					
				</TableBody>
			</Table>
		</Grid>
	)

}
